
import { defineComponent, reactive } from "vue";

interface IState {
  showTimmaBooking: boolean;
  showClientoBooking: boolean;
}

export default defineComponent({
  name: "Home",
  components: {},
  setup() {
    const state = reactive<IState>({
      showTimmaBooking: false,
      showClientoBooking: false,
    });

    const timmaBook = () => {
      state.showTimmaBooking = true;
      state.showClientoBooking = false;
    };

    const clientoBook = () => {
      state.showTimmaBooking = false;
      state.showClientoBooking = true;
    };

    return {
      state,
      timmaBook,
      clientoBook,
    };
  },
  mounted() {
    // let iFrameResizerScript = document.createElement("script");
    // iFrameResizerScript.setAttribute(
    //   "src",
    //   "https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/2.8.3/iframeResizer.min.js"
    // );
    // document.head.appendChild(iFrameResizerScript);
    // let iframeTest = document.createElement("script");
    // iframeTest.setAttribute("type", "text/javascript");
    // iframeTest.innerHTML = "iFrameResize({checkOrigin: false});";
  },
});
